module.exports = __webpack_public_path__ + "static/media/freeclover1-01.b1a15bc5.jpg";